export interface Applicant {
  id?: number;
  userId?: number;
  firstName: string;
  middleName?: string;
  lastName: string;
  previousName?: string;
  genderId: number;
  dateOfBirth: string;
  nationalIdNumber: string;
  email?: string;
  primaryPhone: string;
  secondaryPhone?: string;
  certificateApplicationId: number;
  applicantType: number;
  countyOfOriginId: number;
  nationalityId?: number;
  birthCountyId?: number;
  birthTown?: string;
  currentAddress: string;
  occupation?: string;
  placeOfWork?: string;
  wasPreviouslyMarried: boolean;
  previousMarriageDate?: string;
  previousSpouseName?: string;
  fatherName: string;
  motherName: string;
  profileImagePath?: string;
  photoUrl?: string;
  brideProposedName?: string;
  price?: number;
  currencyId?: number;
  currencyName?: string;
}

export interface CreateApplicantDto {
  userId?: number;
  firstName: string;
  middleName?: string;
  lastName: string;
  previousName?: string;
  genderId: number;
  dateOfBirth: string;
  nationalIdNumber: string;
  email?: string;
  primaryPhone: string;
  secondaryPhone?: string;
  roleId?: number;
  certificateApplicationId: number;
  applicantType: string;
  countyOfOriginId: number;
  nationalityId?: number;
  birthCountyId?: number;
  birthTown?: string;
  currentAddress: string;
  occupation?: string;
  placeOfWork?: string;
  wasPreviouslyMarried: boolean;
  previousMarriageDate?: string;
  previousSpouseName?: string;
  fatherName: string;
  motherName: string;
  profileImagePath?: string;
  brideProposedName?: string;
}

export interface UpdateApplicantDto {
  id?: number;
  userId?: number;
  firstName?: string;
  middleName?: string;
  lastName?: string;
  previousName?: string;
  genderId?: number;
  dateOfBirth?: string;
  nationalIdNumber?: string;
  email?: string;
  primaryPhone?: string;
  secondaryPhone?: string;
  certificateApplicationId?: number;
  applicantType?: string;
  countyOfOriginId?: number;
  nationalityId?: number;
  birthCountyId?: number;
  birthTown?: string;
  currentAddress?: string;
  occupation?: string;
  placeOfWork?: string;
  previousMarriageDate?: string;
  previousSpouseName?: string;
  fatherName?: string;
  motherName?: string;
  profileImagePath?: string;
  brideProposedName?: string;
}

export enum ApplicantType {
  Groom = 0,
  Bride = 1,
}
